// Cash-from-client lives in two shapes on a booking, both still in use:
//
//   - `operator_cash_from_client` — the legacy flat field, set when the
//     booking has a single operator (639 bookings in prod carry it).
//   - `operators[].cash_from_client` — the per-operator field used by the
//     multi-operator assignment flow (187 bookings).
//
// Anything reasoning about "does this booking have a cash portion" has to
// look at both, or it silently misses one population.
export const PAYMENT_TYPES_WITH_CASH = ['Cash', 'Mixed Payment'];

// The legacy single-operator amount on its own. The legacy assignment form
// edits only this field, so it needs to know about this shape specifically —
// warning there about cash that actually sits on `operators[]` would point at
// an input showing 0.
export function flatCashPortion(order) {
  return Number(order?.operator_cash_from_client) || 0;
}

export function perOperatorCashPortion(order) {
  return (order?.operators || [])
    .reduce((sum, op) => sum + (Number(op?.cash_from_client) || 0), 0);
}

export function cashPortionTotal(order) {
  if (!order) return 0;
  return flatCashPortion(order) + perOperatorCashPortion(order);
}

export function paymentTypeImpliesCash(order) {
  return PAYMENT_TYPES_WITH_CASH.includes(order?.payment?.type);
}

// True when a cash amount is recorded but the payment type no longer says
// cash was collected — e.g. someone switched Cash → Card Transfer and the
// amount stayed behind. The booking keeps crediting that cash against the
// operator's balance while nothing on screen explains where it came from.
export function hasOrphanCashPortion(order) {
  return cashPortionTotal(order) > 0 && !paymentTypeImpliesCash(order);
}

// Scoped to the legacy flat field, for the single-operator assignment form.
export function hasOrphanFlatCash(order) {
  return flatCashPortion(order) > 0 && !paymentTypeImpliesCash(order);
}
